import { Sparkles, UserCheck } from 'lucide-react'
import type { MissingEssential } from '@/hooks/useInstructorThemeStats'
import { PlayButton } from '@/components/player/PlayButton'
import { lookupTrack } from '@/components/player/tracks'
import { SpotlightCard } from '@/components/dashboard/fx/SpotlightCard'

interface EssentialsGapListProps {
  essentials: MissingEssential[]
}

export function EssentialsGapList({ essentials }: EssentialsGapListProps) {
  return (
    <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {essentials.map((track) => (
        <li key={`${track.artist_name}-${track.track_name}`}>
          <SpotlightCard className="flex h-full items-start gap-4 rounded-2xl p-4">
            <span className="w-10 shrink-0 font-display text-3xl font-semibold leading-none tracking-tighter text-outline">
              {track.rank}
            </span>
            <div className="flex min-w-0 flex-1 flex-col gap-1">
              <span className="truncate font-medium">{track.track_name}</span>
              <span className="truncate text-sm text-muted-foreground">{track.artist_name}</span>
              <span
                className={
                  track.artist_already_played
                    ? 'mt-1 flex w-fit items-center gap-1 rounded-full bg-muted px-2.5 py-0.5 text-[11px] text-muted-foreground'
                    : 'mt-1 flex w-fit items-center gap-1 rounded-full bg-primary/10 px-2.5 py-0.5 text-[11px] font-medium text-primary'
                }
              >
                {track.artist_already_played ? (
                  <>
                    <UserCheck className="size-3" />
                    Knows the artist
                  </>
                ) : (
                  <>
                    <Sparkles className="size-3" />
                    New artist
                  </>
                )}
              </span>
            </div>
            {/* These aren't in the catalog, so the preview is looked up by
                artist + title rather than by song id. */}
            <PlayButton track={lookupTrack(track.artist_name, track.track_name)} className="size-9 shrink-0 self-center" />
          </SpotlightCard>
        </li>
      ))}
    </ul>
  )
}
